import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import Modal from 'react-modal'
import { BrowserRouter } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/ru'

import App from './App'
import * as serviceWorker from './serviceWorker'
import store from './redux/store'

import './index.scss'

moment.locale('ru')
Modal.setAppElement('#root')

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
